import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { poucherApi } from 'services';
import settingsReducer from 'store/settings/settings.slice';

export const configureStoreOptions = {
  reducer: {
    settings: settingsReducer,
    [poucherApi.reducerPath]: poucherApi.reducer,
  },
  middleware: (getDefaultMiddleware: any) => getDefaultMiddleware().concat(poucherApi.middleware),
};

export const store = configureStore({
  reducer: {
    settings: settingsReducer,
    [poucherApi.reducerPath]: poucherApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(poucherApi.middleware),
});

// Enables refetchOnFocus / refetchOnReconnect for the queries that opt in (the notification badge)
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
